import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Wrench, ShoppingCart, UserCog, Settings, LogOut, ChevronRight } from 'lucide-react';
import { useAuth } from '../auth/AuthContext';
export function Sidebar({
  isMobile,
  closeMobileMenu
}: {
  isMobile?: boolean;
  closeMobileMenu?: () => void;
}) {
  const location = useLocation();
  const {
    logout
  } = useAuth();
  const isActive = (path: string) => {
    return location.pathname === path;
  };
  const handleClick = () => {
    if (isMobile && closeMobileMenu) {
      closeMobileMenu();
    }
  };
  const navItems = [{
    name: 'Dashboard',
    path: '/vendor/dashboard',
    icon: <LayoutDashboard size={20} data-id="element-502" />
  }, {
    name: 'Services',
    path: '/vendor/services',
    icon: <Wrench size={20} data-id="element-503" />
  }, {
    name: 'Orders',
    path: '/vendor/orders',
    icon: <ShoppingCart size={20} data-id="element-504" />
  }, {
    name: 'Profile',
    path: '/vendor/profile',
    icon: <UserCog size={20} data-id="element-505" />
  }, {
    name: 'Settings',
    path: '/vendor/settings',
    icon: <Settings size={20} data-id="element-506" />
  }];
  return <div className={`h-full flex flex-col bg-white border-r border-gray-200 ${isMobile ? 'w-full' : 'w-64'}`} data-id="element-507">
      <div className="p-4 border-b border-gray-200" data-id="element-508">
        <Link to="/" className="flex items-center" data-id="element-509">
          <span className="text-xl font-bold text-primary" data-id="element-510">Smart Homebox</span>
        </Link>
        <div className="mt-2 text-sm text-gray-500" data-id="element-511">Vendor Portal</div>
      </div>
      <nav className="flex-1 pt-4 pb-4 overflow-y-auto" data-id="element-512">
        <ul className="space-y-1 px-2" data-id="element-513">
          {navItems.map(item => <li key={item.name} data-id="element-514">
              <Link to={item.path} onClick={handleClick} className={`flex items-center px-4 py-3 text-sm rounded-md group transition-colors ${isActive(item.path) ? 'bg-primary/10 text-primary font-medium' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-515">
                <span className="mr-3" data-id="element-516">{item.icon}</span>
                {item.name}
                <ChevronRight size={16} className={`ml-auto opacity-0 group-hover:opacity-100 transition-opacity ${isActive(item.path) ? 'opacity-100' : ''}`} data-id="element-517" />
              </Link>
            </li>)}
        </ul>
      </nav>
      <div className="p-4 border-t border-gray-200" data-id="element-518">
        <button onClick={logout} className="flex items-center w-full px-4 py-3 text-sm text-red-600 rounded-md hover:bg-red-50" data-id="element-519">
          <LogOut size={20} className="mr-3" data-id="element-520" />
          Logout
        </button>
      </div>
    </div>;
}